import React from 'react';
import PropTypes from 'prop-types';
import { useLabels, usePrefs } from 'wsm-common-data';
import { setClassNames } from '@ddc/classnames-js';
import AltStockContent from './AltStockContent';
import AltVinContent from './AltVinContent';
import WindowSticker from '../WindowSticker';
import FullSpecsLink from './FullSpecsLink';

const AltHeading = ({ quickSpecs, deviceType }) => {
	const { vin, stockNumber } = quickSpecs;
	const labels = useLabels();
	const { headingClasses, headingSize } = usePrefs();
	const headingLabel = labels.get('QUICK_SPECS_STOCK_VIN_HEADING');
	const isMobile = deviceType !== 'DESKTOP';
	const flexDirectionClass = isMobile ? 'flex-column' : 'flex-row';
	const flexAlignClass = isMobile ? '' : 'align-items-center';
	const linksStyle = isMobile ? {} : { marginLeft: 'auto' };

	const headingWrapperClasses = setClassNames([
		'd-flex',
		'mb-5',
		'flex-wrap',
		flexDirectionClass,
		flexAlignClass,
		headingClasses
	]);

	const headingClassNames = setClassNames([headingSize, 'mb-0', 'mt-0']);

	return (
		<div className={headingWrapperClasses}>
			<h3 className={headingClassNames} aria-level="2">
				{headingLabel}{' '}
			</h3>
			<div>
				<AltVinContent vin={vin} isMobile={isMobile} />
				<AltStockContent stockNumber={stockNumber} />
			</div>
			<div style={linksStyle}>
				<FullSpecsLink isMobile={isMobile} />
				<WindowSticker />
			</div>
		</div>
	);
};

AltHeading.propTypes = {
	quickSpecs: PropTypes.shape({
		vin: PropTypes.string,
		stockNumber: PropTypes.string
	}).isRequired,
	deviceType: PropTypes.string.isRequired
};

export default AltHeading;
